<template>
  <div class="app-card-deck">
    <div class="card app-card shadow">
      <div class="card-header app-card-header align-left">
        <div class="track-list-logos-container">
            <div class="row track-list-logos-row">
              <div v-if="panelHeader !== undefined && panelHeader === 'Drills'">
                <img src="../assets/cd-head-image.jpg" class="track-list-logo">
                <h1 class="track-title">Drilling: <span style="color:red;">Step or Set Repeating</span></h1>
              </div>
              <div class="track-list-logos-col text-center" v-if="panelHeader === undefined || panelHeader !== 'Drills'">
                <img src="../assets/cd-head-image.jpg" class="track-list-logo">
                <!-- <div v-if="isThisAFeis === 'false'">
                  <h1 class="track-title" 
                    v-if="tracks[0].category === 'Reels' || 
                          tracks[0].category === 'Slip Jigs' || 
                          tracks[0].category === 'Light Jigs' || 
                          tracks[0].category === 'Heavy Jigs' || 
                          tracks[0].category === 'Hornpipes'">
                    {{ `${tracks[0]?.grade} ${tracks[0]?.category}` }}
                  </h1>
                  <h1 class="track-title" v-if="tracks[0].category === 'Single Jigs'">Single (HOP) Jigs</h1>
                </div> -->

                <!-- <div v-if="isThisAFeis === 'true'"> -->
                  <div v-if="tracks[0].category === 'Reels' || 
                          tracks[0].category === 'Slip Jigs' || 
                          tracks[0].category === 'Light Jigs' || 
                          tracks[0].category === 'Single Jigs' || 
                          tracks[0].category === 'Heavy Jigs' || 
                          tracks[0].category === 'Hornpipes'">
                    <div v-if="tracks[0]?.grade === 'Beginners'">
                      <h1 class="track-title" >{{ `${bunLabel} ${tracks[0]?.category}` }}</h1>
                    </div>
                    <div v-if="tracks[0]?.grade === 'Primary'">
                      <h1 class="track-title" >{{ `${tusLabel} ${tracks[0]?.category}` }}</h1>
                    </div>
                    <div v-if="tracks[0]?.grade === 'Intermediate'">
                      <h1 class="track-title" >{{ `${meanLabel} ${tracks[0]?.category}` }}</h1>
                    </div>
                    <div v-if="tracks[0]?.grade === 'Open'">
                      <h1 class="track-title" >{{ `${openLabel} ${tracks[0]?.category}` }}</h1>
                    </div>
                    <div v-if="tracks[0]?.grade !== 'Beginners' && tracks[0]?.grade !== 'Primary' && tracks[0]?.grade !== 'Intermediate' && tracks[0]?.grade !== 'Open'">
                      <h1 class="track-title" v-if="tracks[0].category === 'Light Jigs'">{{ `${tracks[0]?.category}` }}</h1>
                      <h1 class="track-title" v-if="tracks[0].category === 'Single Jigs'">Single (HOP) Jigs</h1>
                    </div>
                  </div>
                <!-- </div> -->

                <h1 class="track-title" v-if="tracks[0].category === 'Misc'">{{ `${tracks[0]?.grade}` }}</h1>
                <h1 class="track-title" v-if="tracks[0].grade === 'Hornpipe Set Dances' ||  tracks[0].grade === 'Jig Set Dances'">{{ `${tracks[0]?.category}` }}</h1>
                <h1 class="track-title" v-if="tracks[0].grade === 'Trad Set Dances'">{{ `${tracks[0]?.grade}` }}</h1>
              </div>
            </div>
          </div>
      </div>
      <div class="app-card-body">
        <div class="row">
          <div class="col-12">
            <div id="albumListing">
              <div class="trackListing">
                <div class="prev-column">PREV</div>
                <div v-if="tracks[0].category === 'Reels' || tracks[0].category === 'Slip Jigs' || tracks[0].category === 'Light Jigs' || tracks[0].category === 'Single Jigs' || tracks[0].category === 'Heavy Jigs' || tracks[0].category === 'Hornpipes'" class="track-desc-column">{{ `Speed: ${tracks[0]?.speed} bpm, Bars: ${tracks[0]?.bars} ` }}</div>
                <div v-if="tracks[0].grade === 'Showcase'" class="track-desc-column">{{ `${tracks[0]?.grade} ... to show off your creativity.` }}</div>
                <div v-if="tracks[0].grade === 'Hornpipe Set Dances' ||  tracks[0].grade === 'Jig Set Dances' ||  tracks[0].grade === 'Trad Set Dances'" class="track-desc-column">...dance this to the best of your ability!!</div>
                <div v-if="tracks[0].grade === 'Traditional Hornpipe' ||  tracks[0].grade === 'Traditional Heavy Jig'" class="track-desc-column">{{ `Speed: ${tracks[0]?.speed} bpm, Bars: ${tracks[0]?.bars} ` }}</div>
                <div class="select-column">SELECT</div>
              </div>
              <div>
                <div
                  class="trackListingLong"
                  v-for="track in tracks"
                  :key="`${track?.type}_${track?.trackListing}`"
                >
                  <div class="prev-icon">
                    <div v-if="!track.isPlaying">
                      <a v-on:click="optionSelected(track)"
                        ><img
                          src="../assets/sample-button.jpg"
                          width="26"
                          height="26"
                      /></a>
                    </div>
                    <div v-if="track.isPlaying">
                      <a v-on:click="pauseSelected(track)"
                        ><img
                          src="../assets/stop-button.jpg"
                          width="26"
                          height="26"
                      /></a>
                    </div>
                  </div>
                  <div class="track-tune-list">{{ track?.trackListing }}</div>
                  <div class="radio-btn">
                    <input
                      type="radio"
                      :checked="track?.isSelected"
                      name="X1include"
                      @change="optionSelected(track)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
// eslint-disable-next-line no-unused-vars
import IConfigurationService from "../interfaces/configuration_service";

// eslint-disable-next-line no-unused-vars
import SelectedDance from "@/model/selected_dance";
// eslint-disable-next-line no-unused-vars
import { defineComponent, inject, onBeforeMount, PropType, reactive, ref } from "vue";
// eslint-disable-next-line no-unused-vars
import { IRegionFilters } from "@/interfaces/region_filters";
// import AudioPlayer from "./audio_player.vue";

export default defineComponent({
  // components: { AudioPlayer },
  name: "TrackList",
  emits: ["track-selected", "pause-selected"],
  props: {
    panelHeader: String,
    audioFiles: Object as PropType<Array<SelectedDance>>,
    selectedRegion: Object as PropType<IRegionFilters>
  },
  setup(props: any, { emit }) {
    const tracks = reactive(props.audioFiles);
    const configurationService = inject<IConfigurationService>("configurationService");
    const isThisAFeis= ref<string>("false");
    const isThisAClass= ref<string>("false");
    const bunLabel = ref<string>("Bun Grad");
    const tusLabel = ref<string>("Tus Grad");
    const meanLabel = ref<string>("Mean Grad");
    const openLabel = ref<string>("Open");

		if (!configurationService)
    {
      throw new Error("Configuration service not initialised");
    }
    
    // Option button handler
    function optionSelected(track: SelectedDance) {
      for(const trk of tracks)
      {
        trk.isPlaying = false;
      }
      track.isPlaying = true;
      emit("track-selected", track);
    }

    function pauseSelected(track: SelectedDance) {
      track.isPlaying = false;
      emit("pause-selected", track);
    }

    function getFeisStatusAndLabels()
    {
      // const propIsAtFeis = props.selectedRegion?.map((item: IRegionFilters) => item?.isFeis);
      // if (propIsAtFeis)
      // {
        isThisAFeis.value = props.selectedRegion?.map((item: IRegionFilters) => item?.isFeis);
        isThisAClass.value = props.selectedRegion?.map((item: IRegionFilters) => item?.isClass);
        bunLabel.value = props.selectedRegion?.map((item: IRegionFilters) => item?.bunTitle);
        tusLabel.value = props.selectedRegion?.map((item: IRegionFilters) => item?.tusTitle);
        meanLabel.value = props.selectedRegion?.map((item: IRegionFilters) => item?.meanTitle);
        openLabel.value = props.selectedRegion?.map((item: IRegionFilters) => item?.openTitle);
      //   if (propIsAtFeis?.length > 0)
      //   {
      //     isThisAFeis.value = propIsAtFeis[0];
      //     console.log(`BUN LABEL: ${bunLabel.value}`)
      //     console.log(`TUS LABEL: ${tusLabel.value}`)
      //     console.log(`MEAN LABEL: ${meanLabel.value}`)
      //     console.log(`OPEN LABEL: ${openLabel.value}`)
      //     console.log(`isThisAFeis: ${JSON.stringify(propIsAtFeis[0])} truthy: ${propIsAtFeis[0] === "true"} truthy2: ${isThisAFeis.value === 'true'}`)
      //   }
      // }
    }

    onBeforeMount(function()
    {
      getFeisStatusAndLabels();
    });

    return {
      tracks,
      optionSelected,
      pauseSelected,
      isThisAFeis,
      bunLabel,
      tusLabel,
      meanLabel,
      openLabel
    };
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/palette";
@import "../styles/layout";


.app-card-deck {
  min-width: pxToRem(500px);
  max-width: pxToRem(500px);
  margin-right: 10px;
}
.app-card {
  background: $actions-cards-2;
  text-align: center;
  border: 0px;
}

.app-card-header {
  text-align: left;
  background-color: $actions-cards-2;
  border-bottom: 0px;
  height: 5rem;
  padding-left: 1rem;
  padding-right: 1rem;
}
.app-card-body {
  padding-left: 0;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.trackListingLong {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-style: normal;
  line-height: 18px;
  font-weight: normal;
  color: #333;
  float: left;
  clear: both;
  margin: 0px;
  height: 45px;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: #020056;
  padding: 0px;
}
.prev-icon {
  margin: 0px;
  float: left;
  height: 45px;
  width: 50px;
  text-align: center;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: bold;
  color: #f8600f;
  line-height: 18px;
  padding-right: 0px;
  padding-bottom: 0px;
  padding-left: 10px;
  border-right-width: 1px;
  border-right-style: solid;
  border-right-color: #020056;
  padding-top: 10px;
}
.track-tune-list {
  margin: 0px;
  float: left;
  height: 45px;
  width: 320px;
  text-align: left;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 13px;
  font-style: normal;
  font-weight: normal;
  color: #020056;
  line-height: 18px;
  padding-top: 13px;
  padding-right: 0px;
  padding-bottom: 0px;
  padding-left: 13px;
  border-right-width: 1px;
  border-right-style: solid;
  border-right-color: #020056;
}
.radio-btn {
  margin: 0px;
  float: left;
  height: 33px;
  width: 70px;
  text-align: center;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: bold;
  color: #f9fcff;
  line-height: 18px;
  padding-top: 12px;
  padding-right: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
}

 #albumListing {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
}
.trackListing {
  font-weight: normal;
  float: left;
  padding: 0px;
  margin: 0px;
  height: 28px;
  width: 100%;
  background-color: #020056;
}
.prev-column {
  margin: 0px;
  float: left;
  height: 23px;
  width: 50px;
  text-align: center;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: bold;
  color: #f8600f;
  line-height: 18px;
  padding-top: 5px;
  padding-right: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
}
.track-desc-column {
  margin: 0px;
  float: left;
  height: 23px;
  width: 320px;
  text-align: left;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: bold;
  color: #f9fcff;
  line-height: 18px;
  padding-top: 5px;
  padding-right: 0px;
  padding-bottom: 0px;
  padding-left: 15px;
}
.select-column {
  margin: 0px;
  float: left;
  height: 23px;
  width: 50px;
  text-align: center;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: bold;
  color: #f8600f;
  line-height: 16px;
  padding-top: 6px;
  padding-right: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
}
.track-list-logo
{
  max-height: 89px;
  width: 100%;
}
.track-list-logos-container
{
  display: flex;
  justify-content: center;
  max-height: 89px;
  padding: 0px;
  margin: 0px;
  width: 100%;
}
.track-list-logos-row
{
	margin: 0px;
  padding: 0px;
  height: 89px;
  width: 100%;
}
.track-list-logos-col
{
	margin: 0px;
	padding: 0px;
  height: 89px;
  width: 100%;
}
.track-title
{
	color: $primary-purple-2;
	font-size: 18px;
	font-family: Apple Chancery, cursive;
	font-weight: bold;
	font-style: italic;
	position: relative;
	top: -45px;
	height: 0;
	text-align: center;
}

@media only screen and (max-width: 1920px) {
  .app-card-deck {
    min-width: pxToRem(450px);
    max-width: pxToRem(450px);
  }
  .prev-column {
    line-height: 16px;
    padding-top: 6px;
  }
  .track-desc-column {
    padding-top: 5px;
  }
  .track-tune-list {
    min-width: 320px;
    max-width: 320px;
    font-size: 12px;
    line-height: 12px;
    word-wrap: break-word;
    padding-left: 5px;
  }
  .radio-btn {
      width: 45px;
      font-size: 9px;
  }
  .prev-icon {
    width: 45px;
    font-size: 9px;
    padding-left: 5px;
  }
}

@media only screen and (max-width: 685px) {
  .app-card-deck {
    min-width: pxToRem(450px);
    max-width: pxToRem(450px);
  }
  .prev-column {
    font-size: 10px;
    line-height: 16px;
    padding-top: 6px;
  }
  .track-desc-column,
  .track-tune-list {
    min-width: 320px;
    max-width: 320px;
    font-size: 12px;
    line-height: 12px;
    word-wrap: break-word;
    padding-left: 5px;
  }
  .select-column {
    width: 40px;
    font-size: 10px;
  }
  .radio-btn {
      width: 45px;
      font-size: 9px;
  }
  .prev-icon {
    width: 45px;
    font-size: 9px;
    padding-left: 5px;
  }
  .trackListing {
    height: 40px;
  }
}
@media only screen and (max-width: 415px) {
	.app-card-deck {
    min-width: pxToRem(350px);
    max-width: pxToRem(350px);
  }
  .prev-column {
    width: 60px;
    font-size: 12px;
    line-height: 16px;
    padding-top: 6px;
  }
  .track-desc-column {
    min-width: 205px;
    max-width: 205px;
    font-size: 12px;
    line-height: 12px;
    word-wrap: break-word;
    padding-left: 5px;
  }
  .track-tune-list {
    min-width: 220px;
    max-width: 220px;
    font-size: 12px;
    padding-left: 5px;
  }
  .select-column {
    margin: 0px;
    width: 50px;
    float: left;
    color: #f8600f;
    font-size: 12px;
    line-height: 16px;
    padding-top: 6px;
  }
  .radio-btn {
      width: 45px;
      font-size: 9px;
  }
  .prev-icon {
    width: 45px;
    font-size: 9px;
    padding-left: 5px;
  }
  .trackListing {
    height: 40px;
  }
}
@media only screen and (max-width: 360px) {
	.app-card-deck {
    min-width: pxToRem(330px);
    max-width: pxToRem(330px);
  }
  .prev-column {
    width: 50px;
    font-size: 9px;
    line-height: 16px;
    padding-top: 6px;
  }
  .track-desc-column,
  .track-tune-list {
    min-width: 195px;
    max-width: 195px;
    font-size: 12px;
    line-height: 12px;
    word-wrap: break-word;
    padding-left: 5px;
  }
  .select-column {
    width: 40px;
    margin: 0px;
    float: left;
    color: #f8600f;
    font-size: 9px;
    line-height: 16px;
    padding-top: 6px;
  }
  .radio-btn {
      width: 45px;
      font-size: 9px;
  }
  .prev-icon {
    width: 45px;
    font-size: 9px;
    padding-left: 5px;
  }
  .trackListing {
    height: 40px;
  }
}
@media only screen and (max-width: 320px) {
	.app-card-deck {
    min-width: pxToRem(320px);
    max-width: pxToRem(320px);
  }
  .prev-column {
    width: 50px;
    font-size: 9px;
    line-height: 16px;
    padding-top: 6px;
  }
  .track-desc-column {
    min-width: 195px;
    max-width: 195px;
    font-size: 12px;
    line-height: 12px;
    word-wrap: break-word;
    padding-left: 5px;
  }
  .track-tune-list {
    min-width: 195px;
    max-width: 195px;
    font-size: 12px;
    padding-left: 5px;
  }
  .select-column {
    margin: 0px;
    width: 40px;
    float: left;
    color: #f8600f;
    font-size: 9px;
    line-height: 16px;
    padding-top: 6px;
  }
  .radio-btn {
      width: 45px;
      font-size: 9px;
  }
  .prev-icon {
    width: 45px;
    font-size: 9px;
    padding-left: 5px;
  }
  .trackListing {
    height: 40px;
  }
}
@media only screen and (max-width: 280px) {

	.app-card-deck {
    min-width: pxToRem(280px);
    max-width: pxToRem(280px);
  }
  .prev-column {
    width: 35px;
    font-size: 9px;
    line-height: 16px;
    padding-top: 6px;
  }
  .track-desc-column,
  .track-tune-list {
    min-width: 160px;
    max-width: 160px;
    font-size: 12px;
    line-height: 12px;
    word-wrap: break-word;
    padding-left: 5px;
  }
  .select-column {
    margin: 0px;
    float: left;
    color: #f8600f;
    font-size: 9px;
    line-height: 16px;
    padding-top: 6px;
  }
  .radio-btn {
      width: 45px;
      font-size: 9px;
  }
  .prev-icon {
    width: 45px;
    font-size: 9px;
    padding-left: 5px;
  }
  .trackListing {
    height: 40px;
  }
}
</style>
